import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';

const propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  styles: PropTypes.object.isRequired,
  size: PropTypes.string.isRequired,
  amenities: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
  })).isRequired,
};

const UnitDescription = ({ styles, size, amenities }) => {
  const amenityNames = amenities.map(amenity => amenity.name);
  return (
    <div>
      <strong className={styles.strong}>{size}</strong>
      {amenityNames.length > 0 ? ' - ' : false}
      {amenityNames.join(', ')}
    </div>
  );
};

UnitDescription.propTypes = propTypes;

UnitDescription.fragments = {
  unitGroup: gql`
    fragment UnitDescriptionUnitGroup on UnitGroup {
      amenities {
        name
      }
      size
    }
  `,
};

export default UnitDescription;
